<div class="implicit-i9">
  <div class="implicit-i9__status confirmed">
    You have completed required part for Employment Eligibility Check. Your result is being processed. Please wait for some time.
  </div>
</div>
